/**
 * MODULE: platform/browser/frontend/components/BrowserUnavailableState.tsx
 * PURPOSE: Shown when capability.browser is disabled for the tenant.
 */

import { GlobeAltIcon } from '@heroicons/react/24/outline';
import { BROWSER_CAPABILITY_KEY } from '../hooks/useBrowserCapability';

const isLocalDev =
  typeof import.meta !== 'undefined' &&
  (import.meta as ImportMeta & { env?: { DEV?: boolean } }).env?.DEV === true;

export function BrowserUnavailableState() {
  return (
    <div
      className="flex h-full min-h-[320px] flex-col items-center justify-center gap-4 px-6 py-12 text-center"
      data-testid="browser-unavailable"
    >
      <div className="rounded-full bg-gray-100 p-4 dark:bg-gray-800">
        <GlobeAltIcon className="h-10 w-10 text-gray-500 dark:text-gray-400" aria-hidden />
      </div>
      <div className="max-w-md space-y-2">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">AI Browser not enabled</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Remote browser automation is not available for your workspace. Ask your admin to enable{' '}
          <span className="font-medium">{BROWSER_CAPABILITY_KEY}</span> or upgrade your plan.
        </p>
        {isLocalDev ? (
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Local dev: run <span className="font-mono">make seed-browser</span> then refresh.
          </p>
        ) : null}
      </div>
    </div>
  );
}
